<button
  class="flex-none h-full aspect-square p-4 transition-all transform duration-200 ease-in-out hover:scale-105 active:scale-95 disabled:text-white/60 text-white"
  (click)="onClickBack()"
  [disabled]="colorListEl.scrollLeft === 0"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
    <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
  </svg>
</button>
<div class="relative w-full h-full flex flex-row gap-2 py-2 overflow-x-auto" #colorListEl>
  @for (color of colors(); track color) {
    <button
      class="flex-none h-full aspect-[5/3] rounded transition-all transform duration-200 ease-in-out hover:scale-105 active:scale-95"
      [ngStyle]="{ backgroundColor: color }"
      (click)="onClickColor(color)"
    ></button>
  }
</div>
<button
  class="flex-none h-full aspect-square p-4 transition-all transform duration-200 ease-in-out hover:scale-105 active:scale-95 disabled:text-white/60 text-white"
  (click)="onClickNext()"
  [disabled]="colorListEl.scrollLeft + colorListEl.clientWidth >= colorListEl.scrollWidth"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
    <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
  </svg>
</button>
